import { isNZ } from 'utils';

const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

export const getDvsConsent = (personalDetails = {}) => {
  if (isNZ() && hasOwn(personalDetails, 'hasNzDriverLicence')) {
    return personalDetails.hasNzDriverLicence === 'yes' && !!personalDetails.dvsConsent;
  }

  return !!personalDetails.dvsConsent;
};

export const sanitizeDvsConsent = personalDetails => ({
  ...personalDetails,
  dvsConsent: getDvsConsent(personalDetails),
});
